import { createContext } from 'react';

export interface DrawerContext {
  collapse: boolean;
  toggle: () => void;
}

export const DrawerContext = createContext<DrawerContext>(null as any);
